export default "__VITE_ASSET__Ch2fB_57__"